module.exports = __webpack_public_path__ + "static/media/homeIcon.4ac86463.svg";